import React from 'react';
import { Header, Title } from '../ShelfPage/styles';
import ShelfCreditBalanceCard from '../components/ShelfCreditBalanceCard';
import TemplatesTypeView from '../TemplatesTypeView';
import InputsView from '../InputsView';
import SpecsView from '../SpecsView';
import ConfirmView from '../ConfirmView';
import { GenericNavigationTabs } from 'src/components/BeaconV2Components/SubtabNav/SubtabNavigation';

interface TemplatesTabProps {
  templateTitle: string;
  templateStage: 'type' | 'inputs' | 'specs' | 'confirm';
  setTemplateStage: (s: 'type' | 'inputs' | 'specs' | 'confirm') => void;
  inputsProductUrls: string[];
  setInputsProductUrls: (urls: string[]) => void;
  retailerCount: number;
  setRetailerCount: (n: number) => void;
  frequency: 'daily' | 'weekly' | 'monthly';
  setFrequency: (f: 'daily' | 'weekly' | 'monthly') => void;
  startDate: string | null;
  endDate: string | null;
  setStartDate: (v: string | null) => void;
  setEndDate: (v: string | null) => void;
  projectName: string;
  setProjectName: (v: string) => void;
  onSelectTemplate: (t: 'pricing' | 'content') => void;
  urlsByRetailerId: Record<string, string[]>;
  setUrlsByRetailerId: (m: Record<string, string[]>) => void;
}

const TemplatesTab: React.FC<TemplatesTabProps> = ({
  templateTitle,
  templateStage,
  setTemplateStage,
  inputsProductUrls,
  setInputsProductUrls,
  retailerCount,
  setRetailerCount,
  frequency,
  setFrequency,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  projectName,
  setProjectName,
  onSelectTemplate,
  urlsByRetailerId,
  setUrlsByRetailerId
}) => {
  const stageOrder: ReadonlyArray<'type' | 'inputs' | 'specs' | 'confirm'> = ['type', 'inputs', 'specs', 'confirm'];
  const currentIndex = stageOrder.indexOf(templateStage);

  const navTabs = [
    {
      label: 'Type',
      value: 'type' as const,
      disabled: stageOrder.indexOf('type') > currentIndex,
      onClick: () => setTemplateStage('type')
    },
    {
      label: 'Inputs',
      value: 'inputs' as const,
      disabled: stageOrder.indexOf('inputs') > currentIndex,
      onClick: () => setTemplateStage('inputs')
    },
    {
      label: 'Specifications',
      value: 'specs' as const,
      disabled: stageOrder.indexOf('specs') > currentIndex,
      onClick: () => setTemplateStage('specs')
    },
    {
      label: 'Confirmation',
      value: 'confirm' as const,
      disabled: stageOrder.indexOf('confirm') > currentIndex,
      onClick: () => setTemplateStage('confirm')
    }
  ];
  return (
    <>
      {templateStage === 'type' && (
        <>
          <Header>
            <Title>Agents</Title>
            {/* <ShelfCreditBalanceCard /> */}
          </Header>
          <div style={{ marginBottom: 16 }}>
            <GenericNavigationTabs tab={templateStage} tabs={navTabs} />
          </div>
          <div style={{ width: 1045 }}>
            <TemplatesTypeView onSelectTemplate={(t) => { onSelectTemplate(t); setTemplateStage('inputs'); }} />
          </div>
        </>
      )}

      {templateStage === 'inputs' && (
        <>
          <Header>
            <Title>{templateTitle}</Title>
            {/* <ShelfCreditBalanceCard /> */}
          </Header>
          <div style={{ marginBottom: 16 }}>
            <GenericNavigationTabs tab={templateStage} tabs={navTabs} />
          </div>
          <div style={{ width: 1045 }}>
          <InputsView
            onBack={() => setTemplateStage('type')}
            onNext={(urls) => { setInputsProductUrls(urls); setTemplateStage('specs'); }}
            onRetailerCountChange={(n) => setRetailerCount(n)}
            onProjectNameChange={(name) => { setProjectName(name); }}
            onUrlsByRetailerIdChange={(m) => setUrlsByRetailerId(m)}
            templateType={templateTitle}
          />
          </div>
        </>
      )}

      {templateStage === 'specs' && (
        <>
          <Header>
            <Title>{templateTitle}</Title>
            <ShelfCreditBalanceCard />
          </Header>
          <div style={{ marginBottom: 16 }}>
            <GenericNavigationTabs tab={templateStage} tabs={navTabs} />
          </div>
          <div style={{ width: 1045 }}>
          <SpecsView
            onBack={() => setTemplateStage('inputs')}
            onNext={() => setTemplateStage('confirm')}
            productUrlCount={inputsProductUrls.length}
            retailerCount={retailerCount}
            frequency={frequency}
            onFrequencyChange={(f) => setFrequency(f as any)}
            onDatesChange={(s, e) => {
              setStartDate(s ? s.toISOString() : null);
              setEndDate(e ? e.toISOString() : null);
            }}
          />
          </div>
        </>
      )}

      {templateStage === 'confirm' && (
        <>
          <Header>
            <Title>{templateTitle}</Title>
            {/* <ShelfCreditBalanceCard /> */}
          </Header>
          <div style={{ marginBottom: 16 }}>
            <GenericNavigationTabs tab={templateStage} tabs={navTabs} />
          </div>
          <div style={{ width: 1045 }}>
          <ConfirmView
            onBack={() => setTemplateStage('specs')}
            onComplete={() => setTemplateStage('type')}
            templateTitle={templateTitle}
            productUrlCount={inputsProductUrls.length}
            retailerCount={retailerCount}
            frequency={frequency}
            projectName={projectName || undefined}
            startDate={startDate ?? undefined}
            endDate={endDate ?? undefined}
            urlsByRetailerId={urlsByRetailerId}
          />
          </div>
        </>
      )}
    </>
  );
};

export default TemplatesTab;


